<template>
  <div>
    <div class="bg-dark py-5">
      <div class="container">
        <div class="d-flex flex-column flex-md-row align-items-center">
          <div
            class="pl-0 pr-5 text-white"
          >
            <h5 class="text-white font-esso">
              Berckemeyer Versicherungsmakler<br class="d-none d-md-block"> seit 1795
            </h5>
            <p class="font-esso">
              Berckemeyer steht als unabhängiger <br class="d-none d-md-block"> Versicherungsmakler stets auf Ihrer <br class="d-none d-md-block">Seite und das bereits seit über 225 Jahren.
            </p>
          </div>
          <div class="px-5">
            <img src="../assets/logo_berckemeyer.png">
          </div>
          <div class="px-4">
            <img
              height="100px"
              src="../assets/eg_logo.png"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="copyright bg-gray-dark text-white font-esso">
      <div class="container">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p class="mb-0">
            &copy; Copyright {{ curYear }} Berckemeyer
          </p>
          <ul class="nav justify-content-center">
            <li class="nav-item">
              <a
                class="nav-link active"
                href="mailto:info@berckemeyer.eu"
              >Kontakt</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.berckemeyer-firmen.de/impressum.html"
                target="_blank"
              >Impressum</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.berckemeyer-firmen.de/datenschutz.html"
                target="_blank"
              >Datenschutz</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    curYear: new Date().getFullYear()
  })
}
</script>

<style lang="scss">

  .copyright{
    padding: 30px 0;
    font-size: 14px;

    a{
      color: #fff;
      &:hover{
        color: inherit;
        text-decoration: underline;
      }
    }
  }

</style>
